import React, { forwardRef, useContext } from 'react';
import styled from 'styled-components';
import { IconNavigationLinkExternal } from '@s-group/design-system-icons';
import { LinkStyle } from './Link.styles.js';
import { useCard } from '../Card/hooks.js';
import 'polished';
import '@s-group/design-system-tokens/web/tokens/size.es6.js';
import { useCombinedRef } from '../common/hooks.js';
import { LinkContext } from './LinkContext.js';

const defaultProps = {
    external: false,
    standalone: false,
    color: 'primary',
    iconPos: 'after',
    visitedStyle: true,
};
const isExternalIconProps = (icon) => !Array.isArray(icon) &&
    typeof icon === 'object' &&
    icon !== null &&
    !('props' in icon);
const RenderIcon = props => {
    const { external, standalone, icon, iconPos } = props;
    if (external) {
        const iconProps = isExternalIconProps(icon) ? icon : undefined;
        return (React.createElement(IconNavigationLinkExternal, { className: `icon-base ${iconPos === 'before' ? 'icon-before' : ''}`, ...iconProps, size: "16" // Enforced size, see https://jira.sok.fi/browse/SDS-1059
         }));
    }
    else if (standalone && icon && !isExternalIconProps(icon)) {
        const [IconComponent, iconProps] = Array.isArray(icon)
            ? icon
            : 'props' in icon
                ? [icon.type, icon.props]
                : [icon];
        return (React.createElement(IconComponent, { className: `icon-base ${iconPos === 'before' ? 'icon-before' : ''}`, ...iconProps, size: "16" // Enforced size, see https://jira.sok.fi/browse/SDS-1059
         }));
    }
    return null;
};
const _Link = forwardRef((props, ref) => {
    const { children, color, external, standalone, icon, iconPos, blockLink, onClick, visitedStyle, ...rest } = props;
    const linkRef = useCombinedRef(ref);
    const cardContext = useCard(!!blockLink, linkRef);
    const onFocusHandler = () => {
        if (blockLink)
            cardContext === null || cardContext === void 0 ? void 0 : cardContext.dispatch({ type: 'focus' });
    };
    const onBlurHandler = () => {
        if (blockLink)
            cardContext === null || cardContext === void 0 ? void 0 : cardContext.dispatch({ type: 'blur' });
    };
    const onClickHandler = event => {
        if (blockLink)
            event.stopPropagation();
        onClick && onClick(event);
    };
    return (React.createElement("a", { target: external ? '_blank' : undefined, rel: external ? 'noopener' : undefined, onFocus: onFocusHandler, onBlur: onBlurHandler, ...rest, onClick: onClickHandler, ref: linkRef }, !external && standalone && iconPos === 'before' ? (React.createElement(React.Fragment, null,
        RenderIcon({ external, standalone, icon, iconPos }),
        "\u200D",
        children)) : (React.createElement(React.Fragment, null,
        children,
        RenderIcon({ external, standalone, icon })))));
});
_Link.displayName = '_Link';
const Link = styled(_Link).attrs(({ visitedStyle }) => {
    var _a;
    const linkContext = useContext(LinkContext);
    return {
        visitedStyle: (_a = linkContext === null || linkContext === void 0 ? void 0 : linkContext.visitedStyle) !== null && _a !== void 0 ? _a : visitedStyle,
    };
}) `
    ${LinkStyle}
`;
Link.defaultProps = defaultProps;

export { Link };
//# sourceMappingURL=Link.js.map
